import React, { ReactNode, CSSProperties, PropsWithChildren } from 'react';
import theme from './Cards.module.scss';
import { classnames } from '@/utils/html';

interface CardSectionProps extends PropsWithChildren {
    caption?: ReactNode;
    width?: string;
    minWidth?: string;
    shrink?: boolean;
    right?: boolean;
    className?: string;
    strong?: boolean;
    contentClassName?: string;
    grow?: boolean;
}

const CardSection: React.FC<CardSectionProps> = ({
    className,
    contentClassName,
    caption,
    children,
    width,
    minWidth,
    right = false,
    strong = false,
    grow = false,
    shrink,
}) => {
    const style: CSSProperties = {};

    if (shrink === undefined) {
        shrink = !width;
    }

    if (minWidth) {
        style.minWidth = minWidth;
    }

    if (width) {
        style.width = width;
    }

    if (grow) {
        style.flexGrow = 1;
    }

    if (!shrink) {
        style.flexShrink = 0;
    }

    return (
        <div
            className={classnames(theme.cardSection, className, {
                [theme.right]: right,
                [theme.strong]: strong,
                [theme.noCaption]: caption === undefined,
            })}
            style={style}>
            {caption && <div className={theme.sectionCaption}>{caption}</div>}
            <div className={classnames(theme.sectionContent, contentClassName)}>{children}</div>
        </div>
    );
};

export default CardSection;